import { monthsLabelIds } from '../config';

const getMonthLabel = (month, intl) => {
	const labelId = monthsLabelIds[Number(month.split('-')[1]) - 1];
	return labelId ? intl.formatMessage({ id: labelId }) : month;
};

export const toChartData = (overview, currency, intl) =>
	overview
		.filter(item => item.currency === currency)
		.sort((a, b) => a.month.localeCompare(b.month))
		.map(item => ({
			month: getMonthLabel(item.month, intl),
			Expenses: Number(item.expenses) || 0,
			Income: Number(item.income) || 0,
		}));
